<mat-form-field appearance="outline" floatLabel="always" color="white" [ngClass]="inputClass">
  <mat-label><ng-content></ng-content></mat-label>

  <mat-select [placeholder]="placeholder" [formControl]="control" [required]="required">
    @for (item of options; track item) {
      <mat-option [value]="valueAccessor(item)" [disabled]="itemDisabled(item)">
        {{ labelFormatter(item) }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
